import { useRouterState } from "@tanstack/react-router";
import { useDiscoveryHost } from "@/components/discovery-host-context";
import { PrivacyNotice } from "@/components/PrivacyNotice";

export function PublicPrivacyNotice() {
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const { isDiscoveryOpen } = useDiscoveryHost();
  // Explicit public pages only. Legal pages mount within their information shell.
  const eligible = ["/", "/one-pager", "/estimate-widget-for-contractors"].includes(pathname.replace(/\/$/, "") || "/");
  return eligible && !isDiscoveryOpen ? <PrivacyNotice /> : null;
}
